import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import {
  qualifiedSharedDividendsReportAccepted,
  qualifiedSharedDividendsReportRejected,
} from "store/actions/qualifiedSharedDividendsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { QualifiedShareDividendFooterProps } from "models/propTypes/qualifiedShareDividendsPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import useQualifiedShareDividendRejectDialog from "./forms/useQualifiedShareDividendRejectDialog";
import QualifiedShareDividendMoreActions from "./moreActions";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QualifiedShareDividendFooter: React.FC<QualifiedShareDividendFooterProps> = (props) => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  const { qualifiedShareDividend, markAsDoneHandler } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const isStateToApprove = qualifiedShareDividendsService.isStateToApprove(qualifiedShareDividend.state);

  const onAcceptSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    qualifiedShareDividend.id && dispatch(qualifiedSharedDividendsReportAccepted(qualifiedShareDividend.id));
  };

  const onQualifiedShareDividendAccept = () => {
    return qualifiedShareDividendsService.approveDividend(props.qualifiedShareDividend.id ?? "");
  };

  const onRejectSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    qualifiedShareDividend.id && dispatch(qualifiedSharedDividendsReportRejected(qualifiedShareDividend.id));
  };

  const onQualifiedShareDividendRejected = async () => {
    dispatch(displayDialog(getRejectDialog(props.qualifiedShareDividend.id ?? "")));
  };

  const onDownloadClick = async () => {
    return qualifiedShareDividendsService.downloadPdf(qualifiedShareDividend.id ?? "");
  };

  const getRejectDialog = useQualifiedShareDividendRejectDialog(onRejectSuccess);

  return isStateToApprove ? (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
          onClick: onQualifiedShareDividendRejected,
          type: StyleEnums.DisplayType.Danger,
        },
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
          onClick: onQualifiedShareDividendAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.QualifiedShareDividends.QualifiedShareDividendsAcceptSuccessMessage
          ),
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      moreActions={
        <QualifiedShareDividendMoreActions
          qualifiedShareDividend={props.qualifiedShareDividend}
          markAsDoneHandler={props.markAsDoneHandler}
        />
      }
      showNavigateBack={props.showNavigateBack}
      disableSuccessMessages={props.disableSuccessMessages}
    />
  ) : (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Download),
          onClick: onDownloadClick,
          type: StyleEnums.DisplayType.Success,
        },
      ]}
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default QualifiedShareDividendFooter;
